
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delegate-guide",
      function () {
        return require("private-next-pages/delegate-guide.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delegate-guide"])
      });
    }
  